export default __webpack_public_path__ + "static/media/ishai-ribbo_od-ishama.3a2fef4c.mp3";